import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  baseUrl,
  timeList,
  generateRequisitionNumber,
} from "../comman/config";
import Select from "react-select";
import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/solid";
import { useNavigate, Link } from "react-router-dom";
import { DateSessionFilter } from "../components/Filter/DateSessionFilter";
import toast, { Toaster } from "react-hot-toast";
import * as XLSX from 'xlsx';
import Loader from "../components/Loader";
import { ItemNameStacked } from '../components/ItemName';
import { menuAboveTable, withMenuOnTop } from "../comman/selectMenu";


// The summary figures are read in kgs planned to 2 decimals, so they are printed at a fixed 2
// places -- a plain subtraction leaves float noise behind (395 - 300.1 is -94.89999999999998).
// Estimation Count is a number of people and carries no decimals, but raw_material stores it in
// a DECIMAL column, so it arrives as "475.00" and is rounded back to a whole number here.
const show2 = (n) => {
  const v = parseFloat(n);
  return isFinite(v) ? v.toFixed(2) : "0.00";
};
const showCount = (n) => {
  const v = parseFloat(n);
  return isFinite(v) ? Math.round(v) : 0;
};

// Each batch card labels its own fields. The labels used to live in one column to the left of
// every card, positioned by hand-tuned top margins (mt-1, mt-6, mt-7, mt-8) that only lined up
// while every field kept its exact height. Repeating them inside the card costs one column of
// width and removes that whole class of drift.
const fieldLabel = "w-28 shrink-0 font-bold";

function KitRequisitionScreen() {
  const today = new Date().toISOString().split("T")[0];
  const [mealList, setMealList] = useState([]);
  const [rmDetailForItem, setRMDetailForItem] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [vesselList, setVesselList] = useState([]);
  const [ingredientList, setIngredientList] = useState([]);
  const [date, setDate] = useState(today);
  const [session, setSession] = useState("");
  const [formData, setFormData] = useState([{
    batch:  1,
    planned_batch_raw_qty: "",
    vessel_id: "",
    start_time: "",
    end_time:"",
    requisition_no: "",
    remarks: "",
    ingredientDetail: []

  }]);
  const [totalPlannedQty, setTotalPlannedQty] = useState(0);
  const [detail, setDetail] = useState([]);
  const role = localStorage.getItem('userRole');
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getVesselList();
    getIngredientList();
  }, []);
  // useEffect(() => {
  //   let initialFormData;
  //   if(detail.length > 0){
  //     initialFormData = Array.from({ length: detail.length }, (_, index) => ({
  //         batch: index + 1,
  //         planned_batch_raw_qty: "",
  //         vessel_id: "",
  //         start_time: "",
  //         end_time:"",
  //         requisition_no: "",
  //         remarks: "",
  //         ingredientDetail: []
  //       }));
  //   }else{
  //     initialFormData = [{
  //       batch:  1,
  //       planned_batch_raw_qty: "",
  //       vessel_id: "",
  //       start_time: "",
  //       end_time:"",
  //       requisition_no: "",
  //       remarks: "",
  //       ingredientDetail: []
    
  //     }]
  //   }
  //       // Create initial formData and validationErrors based on mealList length
  //   console.log(initialFormData);
  //   // setFormData(initialFormData);
  // }, [detail]);

  useEffect(() => {
    if (mealList.length > 0 && activeIndex != null) {
      getRMDetailForItem();
    }
  }, [mealList, activeIndex]);

  useEffect(() => {
    if (mealList.length > 0 && activeIndex != null) {
      const itemId =
        mealList.find((item, index) => index === activeIndex)?.menu_item_id ??
        null;
      // console.log(itemId);
      const fetchDetail = async () => {
        setLoading(true)
        const condition = `menu_item_id='${itemId}' AND date = '${date}' AND session='${session.value}'`;

        // Batch the 3 pre-loop calls into a single request
        const preBatch = (await axios.post(`${baseUrl}/comman/batch-list`, {
          queries: [
            { key: 'pp',      table: 'production_planning',         condition },
            { key: 'rp',      table: 'receipe_planning',            condition: `${condition} order by id asc` },
            { key: 'prp_grp', table: 'production_receipe_planning', condition: `${condition} GROUP BY ingredient_id order by id asc` },
          ]
        })).data.data;

        let ddArray = [];
        if (preBatch.rp.length > 0) {
          preBatch.rp.forEach((item) => {
            const data = ingredientList.find((v) => v.id == item.ingredient_id);
            if (data) {
              ddArray.push({ingredient_id: data?.id ?? "", name: data.ingredient, unit: data.unit, stdQty: item.std_qty, required_qty: item.required_qty, baseQty: item.std_qty, store: data.store, itemDisable: false});
            }
          });
        }

        setDetail(preBatch.pp);
        const apiDetail = preBatch.pp;
        getDetailDispaly(apiDetail, itemId, ddArray);
        setLoading(false)
      };
      fetchDetail();
    }
  }, [mealList, activeIndex, rmDetailForItem]);

  const getDetailDispaly = async (detail, itemId, ddArray) => {
    try {
      if (detail) {
        const initialFormData = Array.from(
          { length: detail.length },
          (_, index) => ({
            batch: index + 1,
            planned_batch_raw_qty: "",
            vessel_id: "",
            start_time: "",
            end_time: "",
            requisition_no: "",
            remarks: "",
            ingredientDetail : ddArray
          })
        );
        // Batch all per-batch queries (production_receipe_planning + item_requirement_master) in one request
        const batchQueries = initialFormData.flatMap(initialItem => {
          const fc = `menu_item_id='${itemId}' AND date = '${date}' AND session='${session.value}' AND batch = '${initialItem.batch}'`;
          return [
            { key: `prp_${initialItem.batch}`, table: 'production_receipe_planning', condition: fc },
            { key: `irm_${initialItem.batch}`, table: 'item_requirement_master',     condition: fc },
          ];
        });
        const batchBd = batchQueries.length > 0
          ? (await axios.post(`${baseUrl}/comman/batch-list`, { queries: batchQueries })).data.data
          : {};

        const updatedFormData = [];
        for (const initialItem of initialFormData) {
          const matchingObject = detail.find(
            (object) => object.batch === initialItem.batch
          );

          if (matchingObject) {
            const vesselId = matchingObject.vessel_id;
            const vesselItem = vesselList.find((item) => item.id == vesselId);
            const vesselObject = vesselItem
              ? { value: vesselItem.id, label: vesselItem.name }
              : { value: "", label: "" };

            const start_time = matchingObject.start_time;
            const timeslotItem = timeList.find((item) => item.value == start_time);
            const timeslotObject = timeslotItem
              ? { value: timeslotItem.value, label: timeslotItem.label }
              : { value: "", label: "" };

            const end_time = matchingObject.end_time;
            const endTimeItem = timeList.find((item) => item.value == end_time);
            const endTimeSlotObject = endTimeItem ? { value: endTimeItem.value, label: endTimeItem.label } : { value: "", label: "" };

            matchingObject.vessel_id = vesselObject;
            matchingObject.start_time = timeslotObject;
            matchingObject.end_time = endTimeSlotObject;
            matchingObject.requisition_no = generateRequisitionNumber(initialItem.batch, activeIndex, date, session, mealList, vesselList, vesselId);

            const prpRows = batchBd[`prp_${initialItem.batch}`] ?? [];
            const itemDisable = prpRows.length > 0;

            const updatedIngredientDetail = initialItem.ingredientDetail.map((item) => {
              const batch_qty = matchingObject?.planned_batch_raw_qty ?? 0;
              const stdQty = ((batch_qty * item.required_qty) / 100).toFixed(3);
              const dbItem = prpRows.find((val) => val.menu_item_id == matchingObject.menu_item_id && val.session == matchingObject.session && val.batch == matchingObject.batch && val.ingredient_id == item.ingredient_id);
              const requiredQty = dbItem ? dbItem.required_qty : ((batch_qty * item.required_qty) / 100).toFixed(3);
              return { ...item, stdQty: stdQty, required_qty: requiredQty, baseQty: stdQty, db_id: dbItem?.id, itemDisable: (role == 0 || role == 1) ? false : itemDisable };
            });

            const irmRows = batchBd[`irm_${initialItem.batch}`] ?? [];
            matchingObject.main_store_issue_status = irmRows[0]?.main_store_issue_status;
            updatedFormData.push({ ...initialItem, ingredientDetail: updatedIngredientDetail, ...matchingObject });
          } else {
            updatedFormData.push({...initialItem});
          }
        };
        setFormData(updatedFormData);
      } else {
       
        setTotalPlannedQty(0);
        const initialFormData = Array.from(
          { length: 1 },
          (_, index) => ({
            batch: index + 1,
            planned_batch_raw_qty: "",
            vessel_id: "",
            start_time: "",
            end_time:"",
            requisition_no: "",
            remarks: "",
            ingredientDetail: ddArray
          })
        );
        setFormData(initialFormData);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    const sum = formData.reduce((total, obj) => {
      const qty = parseFloat(obj.planned_batch_raw_qty);
      return isNaN(qty) ? total : total + qty;
    }, 0);
    setTotalPlannedQty(sum);
  }, [formData]);

  const handleClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const getVesselList = async () => {
    const response = await axios.get(
      `${baseUrl}/comman/list?table=vessel_master&condition=status=1`
    );
    setVesselList(response.data.data);
  };

  const getIngredientList = async () => {
    const response = await axios.get(`${baseUrl}/ingredients/list?limit=all`);
    const list = response.data.data.filter((item) => item.status == 1);
    setIngredientList(list);
  };

  const getRMDetailForItem = async () => {
    const item_id = mealList.find((item, index) => index == activeIndex);
    const condition = `date = '${date}' AND session = '${session.value}' AND menu_item_id = '${item_id.menu_item_id}'`;
    const response = await axios.get(
      `${baseUrl}/comman/list?table=raw_material&condition=${condition}`
    );
    setRMDetailForItem(response.data.data);
  };

  const handelFilterChange = async (date, session) => {
    setDate(date);
    setSession(session);
    if (date && session) {
      const condition = ` m.session='${session.value}' AND m.date='${date}'`;
      const response = await axios.get(
        `${baseUrl}/meal_master/item_list?condition=${condition}`
      );
      setMealList(response.data.data);
    }
  };

  const handleInputChange = (index) => (e) => {
    const { name, value } = e.target;
    if(name == "planned_batch_raw_qty"){
      setFormData((prevFormData) => {
        const updatedFormData = [...prevFormData];
        const updatedIngredientDetail = updatedFormData[index].ingredientDetail.map((item) => {
          const total_qty = rmDetailForItem?.[0]?.planned_rm_qty ?? 0;
          const batch_qty = value; 
          const requiredQty = total_qty > 0 ? ((batch_qty * item.stdQty) / total_qty).toFixed(3) : 0;
       
          return { ...item,  required_qty : requiredQty };
        })
        
        updatedFormData[index] = { ...updatedFormData[index], [name]: value, ingredientDetail:updatedIngredientDetail };
        // updatedFormData[index] = { ...updatedFormData[index], [name]: value};
        return updatedFormData;
      });
    }else{
      setFormData((prevFormData) => {
        const updatedFormData = [...prevFormData];
        updatedFormData[index] = { ...updatedFormData[index], [name]: value };
        return updatedFormData;
      });
    }
    
  };


  const handleSelectChange = async (index, data, option) => {
    if (option.name == "vessel_id") {
      setFormData((prevFormData) => {
        const updatedFormData = [...prevFormData];
        updatedFormData[index] = {
          ...updatedFormData[index],
          [option.name]: data,
          requisition_no: generateRequisitionNumber(
            updatedFormData[index].batch,
            activeIndex,
            date,
            session,
            mealList,
            vesselList,
            data.value
          ),
        };
        return updatedFormData;
      });
    } else {
      setFormData((prevFormData) => {
        const updatedFormData = [...prevFormData];
        updatedFormData[index] = {
          ...updatedFormData[index],
          [option.name]: data,
        };
        return updatedFormData;
      });
    }
  };

  const handlePlannedQtyChange = (e, formIndex, ingredientIndex) => {
    const { value } = e.target;
    
    setFormData((prevFormData) => {
      return prevFormData.map((batch, index) => {
          if (index + 1 === formIndex) {
              return {
                  ...batch,
                  ingredientDetail: batch.ingredientDetail.map((ingredient, idx) => {
                      if (idx === ingredientIndex) {
                          return {
                              ...ingredient,
                              required_qty: value
                          };
                      }
                      return ingredient;
                  })
              };
          }
          return batch;
      });
    });
  };
  const handleSave = async (e, index) => {
    e.preventDefault();

    const menu_item_id =
      mealList.find((item, i) => i == activeIndex)?.menu_item_id ?? 0;
    const combineData = {
      formData: formData[index],
      date: date,
      session: session,
      menu_item_id: menu_item_id,
    };
    console.log(combineData);
    try {
      // setPopupOpen(true);

      await axios.post(`${baseUrl}/production_planning/batch`, combineData);
      // toast.success("Data successfully saved!");
    } catch (error) {
      toast.error("Failed to submit the form.");
      // setPopupOpen(false);
      console.log(error);
    }
  };

  const handleSubmitRequirement = async(e, index) => {
   
    e.preventDefault();
    if(window.confirm(` 
      આ કીટ ઇસ્યુ થવા જઈ રહી છે. હવે પછી કીટ માં કોઈ સુધારો થઇ શકશે નહી.
      કોઈ કારણસર કોઈ સુધારો કરવાનો થાય તો સ્ટોર ને જાણ કરવી.
      શું તમે કીટ ઇસ્યુ કરવા માંગો છો ?`)
    ){
      const menu_item_id = mealList.find((item, i) => i == activeIndex)?.menu_item_id ?? 0;
      const combineData = {
        formData: formData[index],
        date: date,
        session: session,
        menu_item_id: menu_item_id,
      };
      // console.log(combineData);
      try {
        // setPopupOpen(true);

        await axios.post(`${baseUrl}/production_planning/submit_requirement`, combineData);
        toast.success("Data successfully saved!");
      } catch (error) {
        toast.error("Failed to submit the form.");
        // setPopupOpen(false);
        console.log(error);
      }
    }

  }
  const handleExport = async (e, index) => {
    e.preventDefault();

    const menu_item = mealList.find((_item, i) => i === activeIndex);
    const wb = XLSX.utils.book_new();

    // Group ingredients by store name (from ingredients_master.store)
    const ingredientsByStore = {};
    formData[index].ingredientDetail.forEach(item => {
      const storeName = item.store?.name || 'Main Store';
      if (!ingredientsByStore[storeName]) ingredientsByStore[storeName] = [];
      ingredientsByStore[storeName].push(item);
    });

    const dateStr = date;
    const sessionLabel = session?.label || '';
    const itemName = menu_item?.item_name || '';
    const vesselLabel = formData[index].vessel_id?.label || 'No Vessel';
    const batchNo = formData[index].batch ?? '';
    const kitNo = formData[index].requisition_no || '';
    // The two plan figures the kit is worked out from. Estimation Count is the day's and is the
    // same on every batch's sheet; Batch QTY is this batch's own planned raw qty -- the figure
    // each ingredient's Reqd. is scaled by, so a printed sheet says what its quantities came
    // from. Both are printed the way the screen prints them: a whole number of people, and kgs
    // to two places.
    const estimationCount = showCount(rmDetailForItem?.[0]?.estimated_count ?? 0);
    const batchQty = show2(formData[index].planned_batch_raw_qty ?? 0);

    const PAD_ROWS = 5; // empty numbered rows after data, for handwritten use

    const buildSheet = (titleSuffix, items) => {
      const headerRows = [
        [`Kit Requisition   (${titleSuffix})`, '', '', '', '', '', '', '', ''],
        ['', '', '', '', '', '', '', '', ''],
        [`Date : ${dateStr}`, '', `Session : ${sessionLabel}`, '', `Item : ${itemName}`, '', '', '', ''],
        [`Vessel: ${vesselLabel}`, '', `Batch: ${batchNo}`, '', `Kit No: ${kitNo}`, '', '', '', ''],
        [`Estimation Count: ${estimationCount}`, '', `Batch QTY: ${batchQty}`, '', '', '', '', '', ''],
        ['', '', '', '', '', '', '', '', ''],
        ['#', 'Ingredients', 'Unit', 'જરૂરી (Reqd.)', 'મોકલેલ (Store Issue)', 'મળેલ (Supp. Recd.)', 'બચેલું (Excess)', 'વપરાયેલ (Consumed)', 'રીટર્ન (Return)'],
      ];

      const dataRows = items.map((item, idx) => [
        idx + 1,
        item.name,
        item.unit?.name || '',
        item.required_qty,
        '', '', '', '', ''
      ]);

      const padRows = Array.from({ length: PAD_ROWS }, (_, i) => [
        items.length + i + 1, '', '', '', '', '', '', '', ''
      ]);

      const ws = XLSX.utils.aoa_to_sheet([...headerRows, ...dataRows, ...padRows]);

      // Merges: title row (A:I), then the three detail rows, each split A:B / C:D / E:I so the
      // labels line up in a column down the block.
      ws['!merges'] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 8 } },          // Row 1: title spans A:I
        { s: { r: 2, c: 0 }, e: { r: 2, c: 1 } },          // Row 3: Date  A:B
        { s: { r: 2, c: 2 }, e: { r: 2, c: 3 } },          // Row 3: Sess  C:D
        { s: { r: 2, c: 4 }, e: { r: 2, c: 8 } },          // Row 3: Item  E:I
        { s: { r: 3, c: 0 }, e: { r: 3, c: 1 } },          // Row 4: Vess  A:B
        { s: { r: 3, c: 2 }, e: { r: 3, c: 3 } },          // Row 4: Batch C:D
        { s: { r: 3, c: 4 }, e: { r: 3, c: 8 } },          // Row 4: KitNo E:I
        { s: { r: 4, c: 0 }, e: { r: 4, c: 1 } },          // Row 5: Est. Count A:B
        { s: { r: 4, c: 2 }, e: { r: 4, c: 3 } },          // Row 5: Batch QTY  C:D
        { s: { r: 4, c: 4 }, e: { r: 4, c: 8 } },          // Row 5: (spare)    E:I
      ];

      ws['!cols'] = [
        { wch: 4 },   // #
        { wch: 28 },  // Ingredients
        { wch: 6 },   // Unit
        { wch: 10 },  // Reqd
        { wch: 14 },  // Store Issue
        { wch: 14 },  // Supp Recd
        { wch: 12 },  // Excess
        { wch: 12 },  // Consumed
        { wch: 10 },  // Return
      ];

      return ws;
    };

    // Tab 1: ALL — every ingredient regardless of store
    const allWs = buildSheet('All Stores', formData[index].ingredientDetail);
    XLSX.utils.book_append_sheet(wb, allWs, 'ALL');

    // Tabs 2..N: one per distinct store name
    Object.entries(ingredientsByStore).forEach(([storeName, items]) => {
      const ws = buildSheet(storeName, items);
      // Excel sheet names: max 31 chars, no \ / ? * [ ] :
      const safeName = storeName.replace(/[\\/?*[\]:]/g, '_').slice(0, 31);
      XLSX.utils.book_append_sheet(wb, ws, safeName);
    });

    const filename = (formData?.[index]?.requisition_no || 'Kit_Requisition').replace(/\//g, '-');
    XLSX.writeFile(wb, `${filename}_Kit_Requisition.xlsx`);
  };


  return (
    <div className="">
      {loading && <Loader/>}
      <div className="flex justify-between items-center py-4 px-6">
        <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">
        Kit Requisition
        </h1>
        <Toaster position="top-center" reverseOrder={false} />
        {/* <div>
                    <Link to="/menu/add">
                        <button className="px-4 py-2 bg-blue-500 text-white rounded-md placeholder:text-sm mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Add Menuitem</button>
                    </Link>
                </div> */}
      </div>
      <div className="relative  shadow-md sm:rounded-lg">
        <DateSessionFilter handleFilterChange={handelFilterChange} />
        <div>
          {mealList.map((item, index) => (
            <div key={index} className="border-b mt-4">
              <div
                className="flex justify-between items-center p-4 cursor-pointer accordion-title bg-orange-400 border rounded"
                onClick={() => handleClick(index)}
              >
                <span><ItemNameStacked item={item} /></span>
                {index === activeIndex ? (
                  <ChevronUpIcon className="w-6 h-6" />
                ) : (
                  <ChevronDownIcon className="w-6 h-6" />
                )}
              </div>
              {index === activeIndex && (
                <div className="space-y-2 p-4 bg-white">
                  {/* The plan, as a strip rather than a four-row list: three figures read
                      across in the space the list took vertically, leaving the batches higher up
                      the screen. Planned RAS is not among them -- it is the Production Estimation
                      figure the plan was derived from, not something a kit is measured against,
                      and the new design drops it to buy the width. */}
                  <table className="border-collapse text-sm">
                    <thead>
                      <tr className="bg-gray-50">
                        <th className="border px-3 py-1 font-bold">Estimation Count</th>
                        <th className="border px-3 py-1 font-bold">Planned RM (kgs)</th>
                        <th className="border px-3 py-1 font-bold">Pending RM (kgs)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="text-center">
                        <td className="border px-3 py-1">{showCount(rmDetailForItem?.[0]?.estimated_count ?? 0)}</td>
                        <td className="border px-3 py-1">{show2(rmDetailForItem?.[0]?.planned_rm_qty ?? 0)}</td>
                        <td className="border px-3 py-1">{show2(rmDetailForItem?.[0]?.planned_rm_qty - totalPlannedQty)}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="flex overflow-x-auto">
                    {(!detail || detail.length === 0) ? (
                      <div className="ms-2 flex-1 p-4">
                        <p className="font-bold text-center bg-red-100 p-3 rounded text-red-700">
                          Please save Planned Batch Raw Qty in Production Planning Screen
                        </p>
                      </div>
                    ) : (Array.from({ length: detail.length }, (_, index) => (
                      <div
                        key={index}
                        className="mb-4 ms-2 flex-shrink-0 border rounded"
                      >
                        <div className="border-b p-2 flex items-center gap-2">
                          <span className={fieldLabel}>Batch No.</span>
                          {index + 1}
                        </div>
                        <div className="border-b p-2 flex items-center gap-2">
                          <span className={fieldLabel}>Batch Qty</span>
                          <input
                            type="number"
                            step="0.01"
                            id="planned_batch_raw_qty"
                            placeholder="Planned Batch Raw Qty"
                            name="planned_batch_raw_qty"
                            value={formData?.[index]?.planned_batch_raw_qty}
                            onChange={handleInputChange(index)}
                            // disabled={formData?.[index]?.ingredientDetail.some((item) => item.itemDisable == true)}
                            disabled={true}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                            className="w-full p-1 border rounded-md placeholder:text-s"
                          />
                        </div>
                        <div className="border-b p-2 flex items-center gap-2">
                          <span className={fieldLabel}>Vessel Name</span>
                          <Select
                            {...menuAboveTable}
                            classNamePrefix="select"
                            name="vessel_id"
                            styles={withMenuOnTop({
                              placeholder: (provided) => ({
                                ...provided,
                                fontSize: "0.80rem",
                              }),
                              control: (provided) => ({
                                ...provided,
                                // backgroundColor: "#FFFAF0",
                                fontSize: "16px",
                              }),
                            })}
                            className="flex-1"
                            value={formData?.[index]?.vessel_id}
                            onChange={(selectedOption, name) => {
                              handleSelectChange(index, selectedOption, name);
                            }}
                            placeholder="Vessel Name"
                            options={vesselList.map((item) => ({
                              value: item.id,
                              label: item.name,
                            }))}
                            // isDisabled={formData?.[index]?.ingredientDetail.some((item) => item.itemDisable == true)}
                            isDisabled={true}
                            filterOption={(option, inputValue) => {
                              return option.data.label
                                .toLowerCase()
                                .includes(inputValue.toLowerCase());
                            }}
                          />
                        </div>
                        <div className="border-b p-2 flex items-center gap-2">
                          <span className={fieldLabel}>Time Slot</span>
                          <Select
                            {...menuAboveTable}
                            classNamePrefix="select"
                            name="start_time"
                            styles={withMenuOnTop({
                              placeholder: (provided) => ({
                                ...provided,
                                fontSize: "0.80rem",
                              }),
                              control: (provided) => ({
                                ...provided,
                                // backgroundColor: '#FFFAF0', 
                                fontSize: '16px', 
                              }),
                            })}
                            value={formData?.[index]?.start_time}
                            onChange={(selectedOption, name) => {
                              handleSelectChange(index, selectedOption, name);
                            }}
                            placeholder="Start Time"
                            className="placeholder:text-sm ms-2 w-48"
                            options={timeList.map((item) => ({
                              value: item.value,
                              label: item.label,
                            }))}
                            // isDisabled={formData?.[index]?.ingredientDetail.some((item) => item.itemDisable == true)}
                            isDisabled={true}
                            filterOption={(option, inputValue) => {
                              return option.data.label
                                .toLowerCase()
                                .includes(inputValue.toLowerCase());
                            }}
                          />
                          <Select
                            {...menuAboveTable}
                            classNamePrefix="select"
                            name="end_time"
                            styles={withMenuOnTop({
                              placeholder: (provided) => ({
                                ...provided,
                                fontSize: "0.80rem",
                              }),
                              control: (provided) => ({
                                ...provided,
                                // backgroundColor: '#FFFAF0', 
                                fontSize: '16px', 
                              }),
                            })}
                            value={formData?.[index]?.end_time}
                            onChange={(selectedOption, name) => {
                              handleSelectChange(index, selectedOption, name);
                            }}
                            placeholder="End Time"
                            className="placeholder:text-sm ms-2 w-48"
                            options={timeList.map((item) => ({
                              value: item.value,
                              label: item.label,
                            }))}
                            // isDisabled={formData?.[index]?.ingredientDetail.some((item) => item.itemDisable == true)}
                            isDisabled={true}
                            filterOption={(option, inputValue) => {
                              return option.data.label
                                .toLowerCase()
                                .includes(inputValue.toLowerCase());
                            }}
                          />
                        </div>
                        <div className="border-b p-2 flex items-center gap-2">
                          <span className={fieldLabel}>Kit No.</span>
                          <input
                            type="text"
                            placeholder="Requisition No."
                            disabled
                            id="requisition_no"
                            name="requisition_no"
                            value={formData?.[index]?.requisition_no}
                            onChange={handleInputChange(index)}
                            className="w-full p-1 border rounded-md placeholder:text-sm"
                          />
                        </div>
                        <div className="border-b p-2">
                          <input
                            type="text"
                            placeholder="Remarks (Store)"
                            id="remarks"
                            name="remarks"
                            value={formData?.[index]?.remarks === 'null' || formData?.[index]?.remarks === null ? '' : formData?.[index]?.remarks}
                            onChange={handleInputChange(index)}
                            disabled={formData?.[index]?.ingredientDetail.some((item) => item.itemDisable == true)}
                            className="w-full border rounded-md p-1 placeholder:text-sm bg-orange-50"
                          />
                        </div>
                        {!(formData?.[index]?.ingredientDetail.length > 0) && <div className="border-b p-2">
                            <p className="font-bold text-center bg-red-100">Please save Recipe in Recipe Plannng Screen</p>
                          </div>}
                        {formData?.[index]?.ingredientDetail.length > 0 && <div className="border-b p-2">
                            <table className="border space-x-1">
                              <thead className="space-x-1">
                                <tr>
                                  <th className="px-3">Ingredients</th>
                                  <th className="px-3">Units</th>
                                  <th className="px-3">Store</th>
                                  <th className="px-3">Recipe Qty</th>
                                  <th className="px-3">Kit Reqd Qty</th>
                                </tr>
                              </thead>
                              <tbody>
                              {formData[index].ingredientDetail.map((item, idx) => (
                                <tr key={idx} className="border">
                                  <td className="text-center">{item.name}</td>
                                  <td className="text-center">{item.unit?.name ?? "-"}</td>
                                  <td className="text-center">{item.store?.name || 'Main Store'}</td>
                                  <td className="text-center">{Number(item.stdQty).toFixed(2)}</td>
                                  <td className="text-center p-1"><input type="number" disabled={item.itemDisable} onWheel={(e) => e.target.blur()} onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}} step="0.01" id={`planned_qty_${index}_${idx}`} placeholder="Planned Qty"  name={`planned_qty_${index}_${idx}`} value={Number(item.required_qty).toFixed(2)} onChange={(e) => handlePlannedQtyChange(e, index+1, idx)} className={`w-24 p-1 border rounded-md placeholder:text-sm ${item.itemDisable ? "" : "bg-orange-50"}`}/></td>
                                </tr>
                              ))}
                              </tbody>
                            </table>
                        </div>}
                        {formData?.[index]?.ingredientDetail.length > 0 && <div className="p-2">
                          {/* <button
                            onClick={(e) => {
                              handleSave(e, index);
                            }}
                            className="px-4 py-2 bg-green-500 text-white rounded-md placeholder:text-sm mr-2 float-right"
                          >
                            Save
                          </button> */}
                          <button
                            onClick={(e) => {
                              handleSave(e, index);
                              handleSubmitRequirement(e, index);
                            }}
                            disabled={formData?.[index]?.ingredientDetail.some((item) => item.itemDisable == true)}
                            className="px-4 py-2 bg-green-500 text-white rounded-md placeholder:text-sm mr-2 float-right"
                          >
                            Submit Kit
                          </button>
                          <button
                            onClick={(e) => {
                              handleExport(e, index);
                            }}
                            className="px-4 py-2 bg-blue-500 text-white rounded-md placeholder:text-sm mr-2"
                          >
                            Export
                          </button>
                        </div>}
                      </div>
                    )))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default KitRequisitionScreen;
